export default __webpack_public_path__ + "static/media/radio-fill-red.a17479e4.svg";